import styled, { css } from 'styled-components'

export const Img = styled.img`
  display: inline;
  border-radius: 16px;
`

export const profileAlignmentStyleCss = css`
  bottom: calc(100% + 20px);
`

export const WrapperButton = styled.div`
  display: flex;
  justify-content: center;
  position: relative;
  margin-top: 20px;
`

export const WrapperImage = styled.div`
  display: flex;
  justify-content: center;
`
